<template>
  <div class="breadcrumb-container">
    <!-- 回退 -->
    <div class="breadcrumb-btn" v-show="show">
      <el-button size="mini" @click="$router.back()">返回</el-button>
    </div>
    <!-- 面包屑导航 -->
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
          <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
          <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  updated() {
    const route = this.$route;
    this.show = route.name !== 'home'
  },
  data() {
    return {
      levelList: null,
      show: false,
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: not-allowed;
    }
    &:hover {
      cursor: pointer;
    }
    .el-breadcrumb__inner {
      a {
        padding: 5px 10px;
        &:hover {
          background: #ebebf2;
          border-radius: 25px;
        }
      }
    }
  }
  .breadcrumb-container{
    display: flex;
    align-items: center;
    .breadcrumb-btn{
      margin-left: 15px;
      transform: translateY(-1px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue